export const uriConstructor = (section, idData = null, params = {}) => {
  console.log("Construyendo URI para la sección:", section, "con idData:", idData, "y params:", params);

  if (!section) {
    throw new Error("Section is undefined or invalid. Please provide a valid section.");
  }

  // Reemplazamos puntos por doble guión bajo
  const formattedSection = section.replace(/\./g, '__');

  const buildQuery = (queryParams = {}) => {
    const filtered = Object.entries(queryParams || {}).filter(([, value]) => {
      if (value === undefined || value === null) return false;
      const normalized = String(value).trim();
      return normalized !== "";
    });
    return new URLSearchParams(filtered).toString();
  };

  // Definición de endpoints
  const URI_SELECTED = {
    // --------------------------------------------
    // CLAIMS (Reclamos)
    // --------------------------------------------
    "CLAIMS__CLAIM_CREATE":           ()    => `/api/reclamos/`,
    "CLAIMS__CLAIM_UPDATE":           (id) => `/api/reclamos/${id}/`,
    "CLAIMS__CLAIM_DELETE":           (id) => `/api/reclamos/${id}/`,
    "CLAIMS__CLAIM_GET_LIST":         ()    => `/api/reclamos/`,
    "CLAIMS__CLAIM_GET_DETAIL":       (id) => `/api/reclamos/${id}/`,
    "CLAIMS__CLAIM_UPDATE_STATUS":    (id) => `/api/reclamos/${id}/update-status/`,
    "CLAIMS__ASIGNACIONES_PROVEEDORES_GET_LIST": () => `/api/reclamos/asignaciones-proveedores/`,
    "CLAIMS__ARCHIVE":               (id) => `/api/reclamos/${id}/archivar/`,
    "CLAIMS__ARCHIVED_LIST":         ()    => `/api/reclamos/archivados/`,
    "CLAIMS__EXPORT":                ()    => `/api/reclamos/export/`,
    "CLAIMS__ARCHIVED_EXPORT":       ()    => `/api/reclamos/archivados/export/`,
    "CLAIMS__ASIGNACIONES_EXPORT":   ()    => `/api/reclamos/asignaciones-proveedores/export/`,
    "CLAIMS__ASIGNACION_GET_DETAIL": (id) => `/api/reclamos/asignaciones-proveedores/${id}/`,
    "CLAIMS__ASIGNACION_ADD_OBS":    (id) => `/api/reclamos/asignaciones-proveedores/${id}/observaciones/`,
    "CLAIMS__OWNERS_BY_CONSORTIUM": () => `/api/reclamos/propietarios-por-consorcio/`,
    "CLAIMS__RECLAMO_ADD_OBS": (id) => `/api/reclamos/${id}/agregar-observacion/`,
    "CLAIMS__RECLAMO_ADD_OBS_PROPIETARIO": (id) => `/api/reclamos/${id}/agregar-observacion-propietario/`,
    "CLAIMS__RECLAMO_INTERNAL_OBS": (id) => `/api/reclamos/${id}/observaciones-internas/`,
    "CLAIMS__CLAIM_HARD_DELETE": (id) => `/api/reclamos/${id}/eliminar-definitivo/`,
    "CLAIMS__CONFIG_CONSORCIO": () => `/api/reclamos/config/consorcio/`,
    // Derivación del reclamo al encargado del consorcio.
    "CLAIMS__ENCARGADOS_DISPONIBLES": (id) => `/api/reclamos/${id}/encargados-disponibles/`,
    "CLAIMS__DERIVAR":                (id) => `/api/reclamos/${id}/derivar/`,
    "CLAIMS__DESDERIVAR":             (id) => `/api/reclamos/${id}/desderivar/`,
    "CLAIMS__CONFIG_CUENTAS": () => `/api/reclamos/config/cuentas/`,
    "CLAIMS__CONFIG_CUENTAS_DETAIL": (id) => `/api/reclamos/config/cuentas/${id}/`,
    "CLAIMS__CONFIG_CUENTAS_SUGERENCIAS_PREVIEW": () => `/api/reclamos/config/cuentas/sugerencias/preview/`,
    "CLAIMS__CONFIG_CUENTAS_SUGERENCIAS_EXECUTE": () => `/api/reclamos/config/cuentas/sugerencias/execute/`,
    "CLAIMS__METRICS": () => `/api/reclamos/metrics/`,
    "CLAIMS__RECLAMO_SET_STATUS": (id) => `/api/reclamos/${id}/update-status/`,


    

    
    

    // Auth
    "USERS__AUTH_LOGIN_USER":         () => `/user/login/`,
    "USERS__AUTH_OWNER_LOGIN_PIN":    () => `/auth/propietario/login-pin/`,
    "USERS__AUTH_OWNER_REQUEST_OTP":  () => `/auth/propietario/request-otp/`,
    "USERS__AUTH_OWNER_VERIFY_OTP": () => `/auth/propietario/verify-otp/`,
    "USERS__AUTH_OWNER_SET_PIN": () => `/auth/propietario/set-pin/`,
    "USERS__AUTH_OWNER_CHANGE_PIN": () => `/auth/propietario/change-pin/`,
    "USERS__AUTH_PROVIDER_LOGIN_PIN": () => `/auth/proveedor/login/`,
    "USERS__AUTH_PROVIDER_REQUEST_OTP": () => `/auth/proveedor/request-otp/`,
    "USERS__AUTH_PROVIDER_VERIFY_OTP": () => `/auth/proveedor/verify-otp/`,
    "USERS__AUTH_PROVIDER_SET_PIN": () => `/auth/proveedor/set-pin/`,
    "USERS__AUTH_REFRESH_TOKEN":      () => `/user/login/refresh/`,
    "USERS__AUTH_LOGOUT_USER":        () => `/user/logout/`,

    // Registro
    "USERS__AUTH_REGISTER_USER":      () => `/user/register/`, // crea usuario principal (exige CUIT)

    // Crear usuario asociado
    "USERS__ASSOCIATED_CREATE":       () => `/user/users/associated-create/`,

    // Password Reset
    "USERS__AUTH_RECOVERY_USER":      () => `/user/password-reset/`,
    "USERS__RESET_PASSWORD_CONFIRM":  ({ uid, token }) => `/user/password-reset-confirm/${uid}/${token}/`,
    "USERS__RESET_PASSWORD":          () => `/user/password-reset/`,

    // Usuarios
    "USERS__LIST_ALL_USERS":          () => `/user/users/`,
    "USERS__GET_DETAIL_USER":         (id) => `/user/users/${id}/`,
    "USERS__UPDATE_USER":             (id) => `/user/users/${id}/`,
    "USERS__DELETE_USER":             (id) => `/user/users/${id}/`,
    "USERS__SET_ROLES":               (id) => `/user/users/${id}/set-roles/`,
    "USERS__USER_EFFECTIVE_PERMISSIONS": (id) => `/user/users/${id}/effective-permissions/`,

    // Módulos y Grupos
    "USERS__MODULES_GET_LIST":        () => `/user/modules/`,
    "USERS__GROUPS_GET_LIST":         () => `/user/groups/`,
    "USERS__GROUPS_GET_DETAIL":       (id) => `/user/groups/${id}/`,
    "USERS__GROUPS_CREATE":           () => `/user/groups/`,
    "USERS__GROUPS_UPDATE":           (id) => `/user/groups/${id}/`,
    "USERS__GROUPS_DELETE":           (id) => `/user/groups/${id}/`,
    "USERS__ROLES_GET_LIST":          () => `/user/roles/`,
    "USERS__ROLES_CREATE":            () => `/user/roles/`,
    "USERS__ROLES_UPDATE":            (id) => `/user/roles/${id}/`,
    "USERS__ROLES_DELETE":            (id) => `/user/roles/${id}/`,
    "USERS__ROLES_AVAILABLE_PERMISSIONS": () => `/user/roles/available-permissions/`,
    "AUTH__ME_CAPABILITIES":          () => `/auth/me/capabilities/`,

    // EMAIL
    "EMAIL__SENDGRID_CONFIG_GET":     () => `/sendgrid-config/`,
    "EMAIL__SENDGRID_CONFIG_UPDATE":  () => `/sendgrid-config/`,
    "EMAIL__SENDGRID_WEBHOOK":        () => `/sendgrid-webhook/`,
    "EMAIL__ATTACHMENT_QR_GET":       (id) => `/attachment-qr/${id}/`,

    

    // CONSORTIUMS (Consorcios) – bancos
    "CONSORTIUMS__BANK_CREATE":     ()    => `/consorcios/bancos/`,
    "CONSORTIUMS__BANK_GET_LIST":   ()    => `/consorcios/bancos/`,
    "CONSORTIUMS__BANK_UPDATE":     (id) => `/consorcios/bancos/${id}/`,
    "CONSORTIUMS__BANK_DELETE":     (id) => `/consorcios/bancos/${id}/`,
    "CONSORTIUMS__BANK_GET_DETAIL": (id) => `/consorcios/bancos/${id}/`,
  

    "CONSORTIUMS__CONSORTIUM_CREATE":     ()    => `/consorcios/consorcios/`,
    "CONSORTIUMS__CONSORTIUM_UPDATE":     (id) => `/consorcios/consorcios/${id}/`,
    "CONSORTIUMS__CONSORTIUM_DELETE":     (id) => `/consorcios/consorcios/${id}/`,
    "CONSORTIUMS__CONSORTIUM_GET_LIST":   ()    => `/consorcios/consorcios/`,
    "CONSORTIUMS__CONSORTIUM_GET_DETAIL": (id) => `/consorcios/consorcios/${id}/`,
    "CONSORTIUMS__LOCATION_NORMALIZE":    ()    => `/consorcios/location/normalize/`,

    "CONSORTIUMS__CONSORTIUM_BULK_IMPORT": () => "/consorcios/importar/",
    "CONSORTIUMS__PERIOD_CREATE":          ()    => `/periodos/`,
    "CONSORTIUMS__PERIOD_GET_LIST":        ()    => `/periodos/listar/`,
    "CONSORTIUMS__PERIOD_GET_DETAIL":      (pk)  => `/periodos/${pk}/`,
    "CONSORTIUMS__PERIOD_UPDATE":          (pk)  => `/periodos/${pk}/cerrar/`,
    "CONSORTIUMS__PERIOD_DELETE":          (pk)  => `/periodos/${pk}/delete/`,
    "CONSORTIUMS__PERIOD_REOPEN":          (pk)  => `/periodos/${pk}/reabrir/`,
    "CONSORTIUMS__PERIOD_VERIFY":          ({ consorcioId, fecha }) =>
                                              `/consorcios/${consorcioId}/verificar_periodo/?fecha=${fecha}`,
    "CONSORTIUMS__PERIOD_VERIFY_MULTIPLE":   (consorcioId) =>
                                              `/consorcios/${consorcioId}/verificar_periodos/`,
    /* CONSORTIUMS – torres */
    "CONSORTIUMS__TOWER_GET_LIST": (consorcioId) => `/consorcios/${consorcioId}/torres/`,
    "CONSORTIUMS__CASH_CREATE":         ()    => `/cajas/`,
    "CONSORTIUMS__CASH_UPDATE":         (id) => `/cajas/${id}/`,
    "CONSORTIUMS__CASH_DELETE":         (id) => `/cajas/${id}/`,
    "CONSORTIUMS__CASH_GET_LIST":       ()    => `/cajas/`,
    "CONSORTIUMS__CASH_GET_DETAIL":     (id) => `/cajas/${id}/`,

    "CONSORTIUMS__OWN_CREATE":          () => `/propietarios/`,
    "CONSORTIUMS__OWN_UPDATE":          (id) => `/propietarios/${id}/`,
    "CONSORTIUMS__OWN_DELETE":          (id) => `/propietarios/${id}/`,
    "CONSORTIUMS__OWN_GET_DETAIL":      (id) => `/propietarios/${id}/`,
    "CONSORTIUMS__OWN_GET_LIST":        () => `/propietarios/`,
    "CONSORTIUMS__OWN_GET_LIST_BY_CONSORTIUM": (consorcioId) => `/consorcios/${consorcioId}/propietarios/`,
    "OWNER__CTA_CTE_EXPORT_PDF": ({ propietario_id, fecha }) =>
      `/cuentascorrientes_propietarios/exportar-pdf/?${buildQuery({
        propietario_id,
        fecha,
      })}`,
    "OWNER__CTA_CTE_EXPORT_EXCEL": ({ propietario_id, fecha_inicio = "", fecha_fin = "" }) =>
      `/cuentascorrientes_propietarios/exportar-excel/?${buildQuery({
        propietario_id,
        fecha_inicio,
        fecha_fin,
      })}`,
    "CONSORTIUMS__BANKS_BY_CONSORCIO":   (consorcioId) => `/bancos-por-consorcio/?consorcio_id=${consorcioId}`,
    "CONSORTIUMS__PROVIDER_GET_LIST": (consorcioId) => `/consorcios/${consorcioId}/proveedores/`,
    "CONSORTIUMS__ENCARGADO_GET_LIST": (consorcioId) => `/consorcios/${consorcioId}/encargados/`,

    // -------------------------------------------------
    // TORRES (sub-unidades de Consorcios)
    // -------------------------------------------------

    /* C → crear una torre dentro de un consorcio */
    "CONSORTIUMS__TORRE_CREATE": (consorcioId) =>
      `/consorcios/${consorcioId}/torres/`,

    /* R → listar todas las torres de un consorcio */
    "CONSORTIUMS__TORRE_GET_LIST": (consorcioId) =>
      `/consorcios/${consorcioId}/torres/`,

    /* R → obtener el detalle de una torre en particular */
    "CONSORTIUMS__TORRE_GET_DETAIL": ({ consorcioId, torreId }) =>
      `/consorcios/${consorcioId}/torres/${torreId}/`,

    /* U → actualizar una torre */
    "CONSORTIUMS__TORRE_UPDATE": ({ consorcioId, torreId }) =>
      `/consorcios/${consorcioId}/torres/${torreId}/`,

    /* D → eliminar una torre */
    "CONSORTIUMS__TORRE_DELETE": ({ consorcioId, torreId }) =>
      `/consorcios/${consorcioId}/torres/${torreId}/`,


    // Listado de retenciones (DeudaAFIP) filtrado por consorcio (y/o periodo)
  "MOVEMENTS__RETENCIONES_AFIP_LIST": (params = {}) => {
    let url = `/pagos/retenciones/list/`;
    const { consorcio_id, periodo_fiscal } = params || {};
    const queries = [];
    if (consorcio_id) queries.push(`consorcio_id=${consorcio_id}`);
    if (periodo_fiscal) queries.push(`periodo_fiscal=${periodo_fiscal}`);
    if (queries.length) url += "?" + queries.join("&");
    return url;
  },

  // Exportar retenciones acumuladas AFIP (csv/txt)
  "MOVEMENTS__RETENCIONES_AFIP_EXPORT": (params = {}) => {
    let url = `/pagos/retenciones/exportar-afip/`;
    const { consorcio_id, periodo_fiscal } = params || {};
    const queries = [];
    if (consorcio_id) queries.push(`consorcio_id=${consorcio_id}`);
    if (periodo_fiscal) queries.push(`periodo_fiscal=${periodo_fiscal}`);
    if (queries.length) url += "?" + queries.join("&");
    return url;
  },

    "MOVEMENTS__RETENCIONES_AFIP_PERIODOS": (params = {}) => {
    let url = `/pagos/retenciones/periodos-fiscales/`;
    const { consorcio_id } = params || {};
    const queries = [];
    if (consorcio_id) queries.push(`consorcio_id=${consorcio_id}`);
    if (queries.length) url += "?" + queries.join("&");
    return url;
  },

  // BOT AI - Reglamento QA Debug (superuser only)
  "BOT_AI__REGQA_DEBUG_PAGES": (consorcioId) => `/bot_ai/reglamento/debug/${consorcioId}/pages/`,
  "BOT_AI__REGQA_DEBUG_CLAUSES": (consorcioId) => `/bot_ai/reglamento/debug/${consorcioId}/clauses/`,
  "BOT_AI__REGQA_DEBUG_UF": (consorcioId) => `/bot_ai/reglamento/debug/${consorcioId}/uf/`,
  "BOT_AI__REGQA_DEBUG_ASK_PREVIEW": (consorcioId) => `/bot_ai/reglamento/debug/${consorcioId}/ask-preview/`,
  "BOT_AI__REGQA_DEBUG_EVENTS": (consorcioId) => `/bot_ai/reglamento/debug/${consorcioId}/events/`,



    // COLLECTIONS (Cobranzas)
    "COLLECTIONS__COLLECTION_CREATE":     ()    => `/cobranzas/`,
    "COLLECTIONS__COLLECTION_UPDATE":     (id) => `/cobranzas/${id}/`,
    "COLLECTIONS__COLLECTION_DELETE":     (id) => `/cobranzas/${id}/`,
    "COLLECTIONS__COLLECTION_GET_LIST":   ()    => `/cobranzas/`,
    "COLLECTIONS__COLLECTION_GET_DETAIL": (id) => `/cobranzas/${id}/`,
    "COLLECTIONS__SUGGESTION_GET_LIST":   ()    => `/correo/cobranzas/suggestions/`,
    "COLLECTIONS__SUGGESTION_GET_DETAIL": (id) => `/correo/cobranzas/suggestions/${id}/`,
    "COLLECTIONS__SUGGESTION_UPDATE":     (id) => `/correo/cobranzas/suggestions/${id}/edit/`,
    "COLLECTIONS__SUGGESTION_CONFIRM":    (id) => `/correo/cobranzas/suggestions/${id}/confirm/`,
    "COLLECTIONS__SUGGESTION_REASSIGN":   (id) => `/correo/cobranzas/suggestions/${id}/reassign/`,
    "COLLECTIONS__SUGGESTION_LINK_EXISTING": (id) => `/correo/cobranzas/suggestions/${id}/link-existing/`,
    "COLLECTIONS__SUGGESTION_DISCARD":    (id) => `/correo/cobranzas/suggestions/${id}/discard/`,
    "COLLECTIONS__SUGGESTION_REANALYZE":  (id) => `/correo/cobranzas/suggestions/${id}/reanalyze/`,
    "COLLECTIONS__CONVENIOS_PAGO_GET_LIST": () => `/convenios-pago/`,
    "COLLECTIONS__CONVENIOS_PAGO_GET_DETAIL": (id) => `/convenios-pago/${id}/`,
    "COLLECTIONS__CONVENIOS_PAGO_CREATE": () => `/convenios-pago/`,
    "COLLECTIONS__CONVENIOS_PAGO_UPDATE": (id) => `/convenios-pago/${id}/`,
    "COLLECTIONS__CONVENIOS_PAGO_AGREGAR_DEUDA": (id) => `/convenios-pago/${id}/agregar-deuda/`,
    "COLLECTIONS__CONVENIOS_PAGO_QUITAR_DEUDA": (id) => `/convenios-pago/${id}/quitar-deuda/`,
    "COLLECTIONS__CONVENIOS_PAGO_GENERAR_CUOTAS": (id) => `/convenios-pago/${id}/generar-cuotas/`,
    "COLLECTIONS__CONVENIOS_PAGO_CONFIRMAR": (id) => `/convenios-pago/${id}/confirmar/`,
    "COLLECTIONS__CONVENIOS_PAGO_ANULAR": (id) => `/convenios-pago/${id}/anular/`,
    "COLLECTIONS__CONVENIOS_PAGO_MARCAR_INCUMPLIDO": (id) => `/convenios-pago/${id}/marcar-incumplido/`,
    "COLLECTIONS__CONVENIOS_PAGO_REVERTIR_INCUMPLIMIENTO": (id) => `/convenios-pago/${id}/revertir-incumplimiento/`,
    "COLLECTIONS__CONVENIOS_PAGO_SALDO_RENEGOCIABLE": (id) => `/convenios-pago/${id}/saldo-renegociable/`,
    "COLLECTIONS__CONVENIOS_PAGO_INICIAR_RENEGOCIACION": (id) => `/convenios-pago/${id}/iniciar-renegociacion/`,
    "COLLECTIONS__CONVENIOS_PAGO_CONFIRMAR_RENEGOCIACION": (id) => `/convenios-pago/${id}/confirmar-renegociacion/`,
    "COLLECTIONS__CONVENIOS_PAGO_CANCELAR_RENEGOCIACION": (id) => `/convenios-pago/${id}/cancelar-renegociacion/`,
    "COLLECTIONS__CONVENIOS_PAGO_DEUDA_DISPONIBLE": () => `/convenios-pago/deuda-disponible/`,
    "COLLECTIONS__CONVENIOS_PAGO_OPCIONES_COBRANZA": ({ consorcio_id, propietario_id }) =>
      `/convenios-pago/opciones-cobranza/?${buildQuery({ consorcio_id, propietario_id })}`,
    "COLLECTIONS__CONVENIOS_PAGO_RESUMEN_PROPIETARIO": ({ consorcio_id, propietario_id }) =>
      `/convenios-pago/resumen-propietario/?${buildQuery({ consorcio_id, propietario_id })}`,
    "COLLECTIONS__CONVENIOS_PAGO_TABLERO": (params = {}) =>
      `/convenios-pago/tablero/?${buildQuery(params)}`,
    "COLLECTIONS__MASIVAS_PREVIEW": (params = {}) =>
      `/cobranzas/masivas/preview/?${buildQuery(params)}`,
    "COLLECTIONS__MASIVAS_CREATE": () => `/cobranzas/masivas/`,

    // MOVEMENTS - CONSORCIOS
    "CONSORTIUMS__MOVEMENT_CREATE":       ()    => `/consorcios/movimientos/`,
    "CONSORTIUMS__MOVEMENT_UPDATE":       (id) => `/consorcios/movimientos/${id}/`,
    "CONSORTIUMS__MOVEMENT_DELETE":       (id) => `/consorcios/movimientos/${id}/`,
    "CONSORTIUMS__MOVEMENT_GET_LIST":     ()    => `/consorcios/movimientos/`,
    "CONSORTIUMS__MOVEMENT_GET_DETAIL":   (id) => `/consorcios/movimientos/${id}/`,
    "CONSORTIUMS__EXPENSE_CONCEPT_GET_LIST": () => `/conceptos-expensa/`,
    "CONSORTIUMS__EXPENSE_CONCEPT_GET_LIST": () => `/conceptos-expensa/`,
    "CONSORTIUMS__EXPENSE_CONCEPT_ACCOUNT_DETAIL": (id) => `/cuenta-corriente-expensa/${id}/detalle/`,
    "MOVEMENTS__CONCEPT_EXPENSA_SUMMARY": () => `/movimientos_financieros/conceptos-resumen-periodo/`,
    "REPORTS__OWNER_DEBT_BREAKDOWN": () => `/reportes/deuda-por-concepto/`,
    "REPORTS__INFORME_VERIFICACION": (id) => `/reportes/informes/${id}/verificacion/`,
    "REPORTS__VERIFICACION_PREVIA": () => `/reportes/verificacion-previa/`,
    "REPORTS__OWNER_CURRENT_DEBT_BREAKDOWN": () => `/reportes/deuda-vigente-por-concepto/`,
    "REPORTS__MOROSOS_CON_CONVENIO": () => `/reportes/morosos-convenios/`,
    "REPORTS__CONVENIOS_PAGO_OPERATIVO": () => `/reportes/convenios-pago/operativo/`,
    "REPORTS__DEUDA_PROPIETARIOS_CONVENIOS": () => `/reportes/deuda-propietarios-convenios/`,
    "REPORTS__COBRANZAS_CONVENIOS": () => `/reportes/cobranzas-convenios/`,

    // MERCADO PAGO
    "MERCADOPAGO__OAUTH_START": (consorcioId) => `/mercadopago/consorcios/${consorcioId}/oauth/start/`,
    "MERCADOPAGO__CONNECTION_STATUS": (consorcioId) => `/mercadopago/consorcios/${consorcioId}/status/`,
    "MERCADOPAGO__REFRESH_TOKEN": (consorcioId) => `/mercadopago/consorcios/${consorcioId}/refresh/`,
    "MERCADOPAGO__BOOTSTRAP_STORE_POS": (consorcioId) => `/mercadopago/consorcios/${consorcioId}/store-pos/bootstrap/`,
    "MERCADOPAGO__GENERATE_QR": (consorcioId) => `/mercadopago/consorcios/${consorcioId}/charges/qr/`,
    "MERCADOPAGO__CHARGE_DETAIL": (chargeId) => `/mercadopago/charges/${chargeId}/`,

    // SURVEYS
    "SURVEYS__LIST": () => `/encuestas/`,
    "SURVEYS__CREATE": () => `/encuestas/`,
    "SURVEYS__DETAIL": (id) => `/encuestas/${id}/`,
    "SURVEYS__UPDATE": (id) => `/encuestas/${id}/`,
    "SURVEYS__DELETE": (id) => `/encuestas/${id}/`,
    "SURVEYS__RESULTS": (id) => `/encuestas/${id}/resultados/`,
    "SURVEYS__PUBLISH": (id) => `/encuestas/${id}/publicar/`,
    "SURVEYS__CLOSE": (id) => `/encuestas/${id}/cerrar/`,
    "SURVEYS__SEND_RESULTS": (id) => `/encuestas/${id}/enviar_resultados/`,

    // BUDGETS / PRESUPUESTOS
    "PRESUPUESTOS__LIST": () => `/presupuestos/`,
    "PRESUPUESTOS__CREATE": () => `/presupuestos/`,
    "PRESUPUESTOS__DETAIL": (id) => `/presupuestos/${id}/`,
    "PRESUPUESTOS__UPDATE": (id) => `/presupuestos/${id}/`,
    "PRESUPUESTOS__DELETE": (id) => `/presupuestos/${id}/`,
    "PRESUPUESTOS__SEND": (id) => `/presupuestos/${id}/enviar/`,
    "PRESUPUESTOS__CLOSE": (id) => `/presupuestos/${id}/cerrar/`,
    "PRESUPUESTOS__RESULTS": (id) => `/presupuestos/${id}/resultados/`,
    "PRESUPUESTOS__ADD_OPTION": (id) => `/presupuestos/${id}/opciones/`,
    "PRESUPUESTOS__OPTION_UPDATE": (id) => `/presupuestos-opciones/${id}/`,
    "PRESUPUESTOS__OPTION_DELETE": (id) => `/presupuestos-opciones/${id}/`,

    // ALTA EN CANALES DE PAGO (SolPay): pagos.views_alta_canal.
    "CANALES_PAGO__ALTA": () => `/canales-pago/alta/`,
    "CANALES_PAGO__ALTA_GUARDAR": () => `/canales-pago/alta/guardar/`,
    "CANALES_PAGO__ALTA_ENVIAR": () => `/canales-pago/alta/enviar/`,

    // DÉBITO AUTOMÁTICO DEL ABONO DE WAM: superadmin (debito_abono.views_superadmin)
    // y pantalla de la administración (debito_abono.views_administracion).
    "DEBITO_ABONO__SUPER_DEBITOS": () => `/api/superadmin/debito-abono/debitos/`,
    "DEBITO_ABONO__SUPER_DEBITO": (id) => `/api/superadmin/debito-abono/debitos/${id}/`,
    "DEBITO_ABONO__SUPER_REENVIAR": (id) => `/api/superadmin/debito-abono/debitos/${id}/reenviar/`,
    "DEBITO_ABONO__SUPER_FECHA": (id) => `/api/superadmin/debito-abono/debitos/${id}/fecha/`,
    "DEBITO_ABONO__SUPER_ANULAR": (id) => `/api/superadmin/debito-abono/debitos/${id}/anular/`,
    "DEBITO_ABONO__SUPER_FACTURAS": () => `/api/superadmin/debito-abono/facturas-programables/`,
    "DEBITO_ABONO__SUPER_PROGRAMAR": (id) => `/api/superadmin/debito-abono/facturas/${id}/programar/`,
    "DEBITO_ABONO__SUPER_ADMINISTRACIONES": () => `/api/superadmin/debito-abono/administraciones/`,
    "DEBITO_ABONO__SUPER_ADMINISTRACION": (id) => `/api/superadmin/debito-abono/administraciones/${id}/`,
    "DEBITO_ABONO__SUPER_DIAS_AVISO": (id) => `/api/superadmin/debito-abono/administraciones/${id}/dias-aviso/`,
    "DEBITO_ABONO__SUPER_REVOCAR": (id) => `/api/superadmin/debito-abono/administraciones/${id}/revocar/`,
    "DEBITO_ABONO__SUPER_PLANTILLAS": () => `/api/superadmin/debito-abono/plantillas/`,
    "DEBITO_ABONO__SUPER_PLANTILLA": (id) => `/api/superadmin/debito-abono/plantillas/${id}/`,
    "DEBITO_ABONO__SUPER_PUBLICAR": (id) => `/api/superadmin/debito-abono/plantillas/${id}/publicar/`,
    "DEBITO_ABONO__SUPER_WAM": () => `/api/superadmin/debito-abono/wam/`,
    "DEBITO_ABONO__SUPER_WAM_ADHERIR": () => `/api/superadmin/debito-abono/wam/adherir/`,
    "DEBITO_ABONO__ESTADO": () => `/api/debito-abono/estado/`,
    "DEBITO_ABONO__CONFIGURACION": () => `/api/debito-abono/configuracion/`,
    "DEBITO_ABONO__VISTA_PREVIA": () => `/api/debito-abono/vista-previa/`,
    "DEBITO_ABONO__FIRMAR": (id) => `/api/debito-abono/autorizaciones/${id}/firmar/`,
    "DEBITO_ABONO__PDF_FIRMADO": (id) => `/api/debito-abono/autorizaciones/${id}/pdf-firmado/`,
    "DEBITO_ABONO__REVOCAR": () => `/api/debito-abono/revocar/`,
    "DEBITO_ABONO__PROXIMOS": () => `/api/debito-abono/debitos/proximos/`,
    "DEBITO_ABONO__HISTORIAL": () => `/api/debito-abono/debitos/historial/`,
    "DEBITO_ABONO__POSTERGAR": (id) => `/api/debito-abono/debitos/${id}/fecha/`,

    // GESTIÓN DE ALQUILERES (contratos propietario-inquilino).
    // OJO: no es la app `alquileres`, que son las cobranzas de renta del
    // consorcio y viven en ALQUILERES__COBRANZAS_*.
    "GESTION_ALQUILERES__CONTRATOS_LIST": () => `/api/gestion-alquileres/contratos/`,
    "GESTION_ALQUILERES__CONTRATOS_CREATE": () => `/api/gestion-alquileres/contratos/`,
    "GESTION_ALQUILERES__CONTRATOS_DETAIL": (id) => `/api/gestion-alquileres/contratos/${id}/`,
    "GESTION_ALQUILERES__CONTRATOS_UPDATE": (id) => `/api/gestion-alquileres/contratos/${id}/`,
    "GESTION_ALQUILERES__CONTRATOS_DELETE": (id) => `/api/gestion-alquileres/contratos/${id}/`,
    "GESTION_ALQUILERES__CONTRATOS_VENCIMIENTOS": () => `/api/gestion-alquileres/contratos/proximos-vencimientos/`,
    "GESTION_ALQUILERES__CUENTA_CORRIENTE": (id) => `/api/gestion-alquileres/contratos/${id}/cuenta-corriente/`,
    "GESTION_ALQUILERES__CUENTA_CORRIENTE_PDF": (id) => `/api/gestion-alquileres/contratos/${id}/cuenta-corriente/pdf/`,
    "GESTION_ALQUILERES__CONTRATOS_GENERAR_RECIBO": (id) => `/api/gestion-alquileres/contratos/${id}/generar-recibo/`,
    "GESTION_ALQUILERES__RECIBOS_LIST": () => `/api/gestion-alquileres/recibos/`,
    "GESTION_ALQUILERES__RECIBOS_DETAIL": (id) => `/api/gestion-alquileres/recibos/${id}/`,
    "GESTION_ALQUILERES__PAGOS_LIST": () => `/api/gestion-alquileres/pagos/`,
    "GESTION_ALQUILERES__PAGOS_CREATE": () => `/api/gestion-alquileres/pagos/`,
    "GESTION_ALQUILERES__PAGOS_DELETE": (id) => `/api/gestion-alquileres/pagos/${id}/`,
    "GESTION_ALQUILERES__PAGOS_CONFIRMAR": (id) => `/api/gestion-alquileres/pagos/${id}/confirmar/`,
    "GESTION_ALQUILERES__PAGOS_RECHAZAR": (id) => `/api/gestion-alquileres/pagos/${id}/rechazar/`,
    "GESTION_ALQUILERES__INGRESOS_LIST": () => `/api/gestion-alquileres/ingresos/`,
    "GESTION_ALQUILERES__AJUSTES_LIST": () => `/api/gestion-alquileres/ajustes/`,
    "GESTION_ALQUILERES__INDICES_FALTANTES": () => `/api/gestion-alquileres/ajustes/indices-faltantes/`,
    "GESTION_ALQUILERES__AJUSTES_UPDATE": (id) => `/api/gestion-alquileres/ajustes/${id}/`,
    "GESTION_ALQUILERES__AJUSTES_APLICAR": (id) => `/api/gestion-alquileres/ajustes/${id}/aplicar/`,
    "GESTION_ALQUILERES__AJUSTES_RECHAZAR": (id) => `/api/gestion-alquileres/ajustes/${id}/rechazar/`,

    // Serie de índices (app `indices`). Tabla GLOBAL, no scopeada por
    // administrador: el ICL de agosto es el mismo para todos.
    "INDICES__VALORES_LIST": () => `/api/indices/valores/`,
    "INDICES__VALORES_CREATE": () => `/api/indices/valores/`,
    "INDICES__VALORES_UPDATE": (id) => `/api/indices/valores/${id}/`,
    "INDICES__VALORES_DELETE": (id) => `/api/indices/valores/${id}/`,

    // INVENTARIO DEL CONSORCIO
    "INVENTARIO__BIENES_LIST": () => `/inventario-bienes/`,
    "INVENTARIO__BIENES_CREATE": () => `/inventario-bienes/`,
    "INVENTARIO__BIENES_DETAIL": (id) => `/inventario-bienes/${id}/`,
    "INVENTARIO__BIENES_UPDATE": (id) => `/inventario-bienes/${id}/`,
    "INVENTARIO__BIENES_DELETE": (id) => `/inventario-bienes/${id}/`,
    "INVENTARIO__ALERTAS": () => `/inventario-bienes/alertas/`,
    "INVENTARIO__RESUMEN": () => `/inventario-bienes/resumen/`,
    "INVENTARIO__REPARACIONES_LIST": () => `/inventario-reparaciones/`,
    "INVENTARIO__REPARACIONES_CREATE": () => `/inventario-reparaciones/`,
    "INVENTARIO__REPARACIONES_DETAIL": (id) => `/inventario-reparaciones/${id}/`,
    "INVENTARIO__REPARACIONES_UPDATE": (id) => `/inventario-reparaciones/${id}/`,
    "INVENTARIO__REPARACIONES_DELETE": (id) => `/inventario-reparaciones/${id}/`,
    "INVENTARIO__MANTENIMIENTO_LIST": () => `/inventario/solicitudes-mantenimiento/`,
    "INVENTARIO__MANTENIMIENTO_CREATE": () => `/inventario/solicitudes-mantenimiento/`,
    "INVENTARIO__MANTENIMIENTO_DETAIL": (id) => `/inventario/solicitudes-mantenimiento/${id}/`,
    "INVENTARIO__MANTENIMIENTO_VALIDAR": (id) => `/inventario/solicitudes-mantenimiento/${id}/confirmar-resultado/`,
    "INVENTARIO__REVISIONES_LIST": () => `/inventario-revisiones/`,
    "INVENTARIO__REVISIONES_CREATE": () => `/inventario-revisiones/`,
    "INVENTARIO__REVISIONES_DETAIL": (id) => `/inventario-revisiones/${id}/`,
    "INVENTARIO__REVISIONES_UPDATE": (id) => `/inventario-revisiones/${id}/`,
    "INVENTARIO__REVISIONES_DELETE": (id) => `/inventario-revisiones/${id}/`,
    "REPORTES__INVENTARIO": () => `/reportes/reportes/inventario/`,
    "REPORTES__INVENTARIO_EXCEL": () => `/reportes/reportes/inventario/export/excel/`,
    "REPORTES__INVENTARIO_PDF": () => `/reportes/reportes/inventario/export/pdf/`,

    // LEGALES - JUICIOS
    "LEGALES__JUICIOS_GET_LIST":   ()    => `/juicios/`,
    "LEGALES__JUICIOS_GET_DETAIL": (id) => `/juicios/${id}/`,
    "LEGALES__JUICIOS_CREATE":     ()    => `/juicios/`,
    "LEGALES__JUICIOS_UPDATE":     (id) => `/juicios/${id}/`,
    "LEGALES__JUICIOS_DELETE":     (id) => `/juicios/${id}/`,

    // Dashboard / Meta
    "META__GLOBAL_SEARCH": () => `/api/search/`,
    "META__NOTIFICATIONS": () => `/api/notifications/`,
    "META__NOTIFICATIONS_STATE": () => `/api/notifications/state/`,
    "META__NOTIFICATIONS_STATE_BULK": () => `/api/notifications/state/bulk/`,

    // Novedades de WAM (lanzamientos de módulos y funciones)
    "NOVEDADES_WAM__LIST": () => `/api/novedades-wam/`,
    "NOVEDADES_WAM__RESUMEN": () => `/api/novedades-wam/resumen/`,
    "NOVEDADES_WAM__LEER_TODAS": () => `/api/novedades-wam/leer-todas/`,
    "NOVEDADES_WAM__LEIDA": (id) => `/api/novedades-wam/${id}/leida/`,
    "NOVEDADES_WAM__MODAL_CERRADO": (id) => `/api/novedades-wam/${id}/modal-cerrado/`,
    "NOVEDADES_WAM__EVENTO": (id) => `/api/novedades-wam/${id}/evento/`,
    "META__JOBS_ACTIVE": () => `/api/jobs/active/`,
    "META__JOB_DETAIL": (taskId) => `/api/jobs/${taskId}/`,
    "META__WEATHER": () => `/api/meta/weather/`,
    "CONSORTIUMS__QUICK_BALANCE": (id) => `/api/consorcios/${id}/quick-balance/`,

    // REFERIDOS
    "REFERRALS__STATS": () => `/referidos/me/`,
    "REFERRALS__ADMINS": () => `/referidos/referidos/`,
    "REFERRALS__COMMISSIONS": () => `/referidos/comisiones/`,

    // INVESTMENTS
    "INVESTMENTS__INVESTMENT_CREATE":     () => `/inversiones/`,
    "INVESTMENTS__INVESTMENT_UPDATE":     (id) => `/inversiones/${id}/`,
    "INVESTMENTS__INVESTMENT_DELETE":     (id) => `/inversiones/${id}/`,
    "INVESTMENTS__INVESTMENT_GET_DETAIL": (id) => `/inversiones/${id}/`,
    "INVESTMENTS__INVESTMENT_CLOSE":      (id) => `/inversiones/${id}/cerrar/`,
    "INVESTMENTS__INVESTMENT_GET_LIST":    () => `/inversiones/`,
    "INVESTMENTS__ACCOUNT_GET_LIST_BY_CONSORCIO": (consorcioId) => `/cuentas-inversion/?consorcio_id=${consorcioId}`,

    // FOREIGN CURRENCY
    "FOREIGNCURRENCY__FX_CREATE":     () => `/monedas-extranjeras/`,
    "FOREIGNCURRENCY__FX_UPDATE":     (id) => `/monedas-extranjeras/${id}/`,
    "FOREIGNCURRENCY__FX_DELETE":     (id) => `/monedas-extranjeras/${id}/`,
    "FOREIGNCURRENCY__FX_GET_LIST":   () => `/monedas-extranjeras/`,
    "FOREIGNCURRENCY__FX_GET_DETAIL": (id) => `/monedas-extranjeras/${id}/`,
    "FOREIGNCURRENCY__BANKS_BY_CONSORCIO": (consorcioId) => `/bancos-por-consorcio/?consorcio_id=${consorcioId}`,

    // RECONCILIATIONS
    "RECONCILIATIONS__CREATE":                () => `/conciliaciones/`,
    "RECONCILIATIONS__UPDATE":                (id) => `/conciliaciones/${id}/`,
    "RECONCILIATIONS__DELETE":                (id) => `/conciliaciones/${id}/`,
    "RECONCILIATIONS__DETAIL":                (id) => `/conciliaciones/${id}/`,
    "RECONCILIATIONS__IMPORT_BANK_STATEMENT": () => `/conciliaciones/importar/`,
    "RECONCILIATIONS__SMART_IMPORT_PREVIEW":  () => `/conciliaciones/extracto/preview/`,
    "RECONCILIATIONS__SMART_IMPORT_CONFIRM": () => `/conciliaciones/extracto/confirmar/`,
    "RECONCILIATIONS__APPEND_STATEMENT_PREVIEW": ({ conciliacionId }) => `/conciliaciones/${conciliacionId}/extracto/agregar-preview/`,
    "RECONCILIATIONS__APPEND_STATEMENT_CONFIRM": ({ conciliacionId }) => `/conciliaciones/${conciliacionId}/extracto/agregar-confirmar/`,
    "RECONCILIATIONS__EXISTING_OF_MONTH": () => `/conciliaciones/del-mes/`,
    "RECONCILIATIONS__GET_BANK_MOVEMENTS":    (id) => `/conciliaciones/${id}/movimientos-banco/`,
    "RECONCILIATIONS__GET_FILE_MOVEMENTS":    (id) => `/conciliaciones/${id}/movimientos-archivo/`,
    "RECONCILIATIONS__SUGGEST_COLLECTION":    ({ conciliacionId, movimientoId }) => `/conciliaciones/${conciliacionId}/movimientos/${movimientoId}/sugerencias-cobranza/`,
    "RECONCILIATIONS__CREATE_COLLECTION":     ({ conciliacionId, movimientoId }) => `/conciliaciones/${conciliacionId}/movimientos/${movimientoId}/crear-cobranza/`,
    "RECONCILIATIONS__CREATE_COLLECTIONS_BULK": ({ conciliacionId, movimientoId }) => `/conciliaciones/${conciliacionId}/movimientos/${movimientoId}/crear-cobranzas-masivas/`,
    "RECONCILIATIONS__SUGGEST_SELECTED_COLLECTIONS": ({ conciliacionId }) => `/conciliaciones/${conciliacionId}/cobranzas-masivas/sugerencias/`,
    "RECONCILIATIONS__CONFIRM_SELECTED_COLLECTIONS": ({ conciliacionId }) => `/conciliaciones/${conciliacionId}/cobranzas-masivas/confirmar/`,
    "RECONCILIATIONS__SUGGEST_PAYMENT":       ({ conciliacionId, movimientoId }) => `/conciliaciones/${conciliacionId}/movimientos/${movimientoId}/sugerencias-pago/`,
    "RECONCILIATIONS__CREATE_PAYMENT":        ({ conciliacionId, movimientoId }) => `/conciliaciones/${conciliacionId}/movimientos/${movimientoId}/crear-pago/`,
    "RECONCILIATIONS__CREATE_EXPENSE_AND_PAYMENT": ({ conciliacionId, movimientoId }) => `/conciliaciones/${conciliacionId}/movimientos/${movimientoId}/crear-gasto-y-pago/`,
    "RECONCILIATIONS__SUGGEST_GROUPED_PAYMENT": ({ conciliacionId }) => `/conciliaciones/${conciliacionId}/pagos-agrupados/sugerencias/`,
    "RECONCILIATIONS__CONFIRM_GROUPED_PAYMENT": ({ conciliacionId }) => `/conciliaciones/${conciliacionId}/pagos-agrupados/confirmar/`,
    "RECONCILIATIONS__EXPENSE_DESCRIPTION_SUGGESTIONS": ({ conciliacionId, proveedorId }) => `/conciliaciones/${conciliacionId}/proveedores/${proveedorId}/sugerencias-descripcion-gasto/`,
    "RECONCILIATIONS__SUGGEST_GROUP":         ({ conciliacionId, movimientoId }) => `/conciliaciones/${conciliacionId}/movimientos/${movimientoId}/sugerencias-grupo/`,
    "RECONCILIATIONS__CONCILIATE_GROUP":      (id) => `/conciliaciones/${id}/conciliar-grupo/`,
    "RECONCILIATIONS__UPDATE_STATUS":         (id) => `/conciliaciones/${id}/actualizar_estado/`,
    "RECONCILIATIONS__CONCILIATE_BATCH":      (id) => `/conciliaciones/${id}/conciliar_lote/`,
    "RECONCILIATIONS__CONCILIATE_MOVEMENT":   () => `/conciliaciones/conciliar_movimiento/`,
    "RECONCILIATIONS__LIST":                  () => `/conciliaciones/`,
    "RECONCILIATIONS__GET_DATA":              (id) => `/conciliaciones/${id}/datos/`,
    "RECONCILIATIONS__DELETE_CONCILIATION":   (id) => `/conciliaciones/${id}/eliminar/`,
    "CONSORTIUMS__CURRENT_ACCOUNT_CASH_LIST": () => `/consorcios/cuenta_corriente_caja/`,
    "CONSORTIUMS__BANK_CHECKING_ACCOUNT_DETAIL": (id) => `/cuenta-corriente-banco/${id}/detalle/`,
    "RECONCILIATIONS__CLOSE":                 (id) => `/conciliaciones/${id}/cerrar/`,
    "RECONCILIATIONS__CONFIRM_BANK_CHARGES":  (id) => `/conciliaciones/${id}/confirmar_gastos_bancarios/`,
    "CONSORTIUMS__CURRENT_ACCOUNT_CASH_LIST": (id) => `/cuenta_corriente_caja/by-caja/${id}/`,
    "RECONCILIATIONS__GET_ACCOUNT_BALANCE":    (id) => `/conciliaciones/${id}/saldo_cuenta/`,
    "RECONCILIATIONS__GENERATE_BANK_EXPENSE":  (id) => `/conciliaciones/${id}/generar_gasto_bancario/`,
    "RECONCILIATIONS__CONCILIATE_AUTO": (id) => `/conciliaciones/${id}/conciliar-automaticamente/`,
    "RECONCILIATIONS__CONFIRM_BANK_EXPENSES": (id) => `/conciliaciones/${id}/confirmar_gastos_bancarios/`,
    "RECONCILIATIONS__SETTLE_UNIDENTIFIED":   (id) => `/conciliaciones/${id}/asentar-no-identificados/`,
    "RECONCILIATIONS__UNMATCH_PAIR":          (id) => `/conciliaciones/${id}/desconciliar-par/`,


    // MOVEMENTS - PAYMENTS
    "MOVEMENTS__PAYMENT_CREATE":      ()    => `/pagos/`,
    "MOVEMENTS__PAYMENT_UPDATE":      (id) => `/pagos/${id}/`,
    "MOVEMENTS__PAYMENT_DELETE":      (id) => `/pagos/${id}/`,
    "MOVEMENTS__PAYMENT_GET_LIST":    ()    => `/pagos-efectuados/`,
    "MOVEMENTS__PAYMENT_GET_DETAIL":  (id) => `/pagos/${id}/`,
    "MOVEMENTS__PAYMENT_SEND_ORDER_EMAIL": (id) => `/pagos/${id}/enviar-orden-email/`,

    // LIQUIDATIONS
    "LIQUIDATIONS__GENERATE":                 () => `/liquidacion/generar/`,
    "LIQUIDATIONS__PREVIEW":                  () => `/liquidacion/previsualizar/`,
    "LIQUIDATIONS__EXPENSES_BY_UF":           (id) => `/liquidacion/expensas-por-uf/${id}/`,
    "LIQUIDATIONS__RECENT":                   () => `/liquidaciones-recientes/`,
    "LIQUIDATIONS__VERIFICACION":             (id) => `/liquidaciones/${id}/verificacion/`,
    "LIQUIDATIONS__DETAIL":                   (id) => `/liquidacion/detalle/${id}/`,
    "LIQUIDATIONS__DELETE":                   (id) => `/liquidacion/eliminar/${id}/`,
    "LIQUIDATIONS__EDIT":                     (id) => `/liquidacion/editar/${id}/`,
    "LIQUIDATIONS__APERTURA_CONCEPTOS":       () => `/liquidacion/apertura-conceptos/`,
    "LIQUIDATIONS__AJUSTE_CONCEPTOS":         () => `/liquidacion/ajuste-conceptos/`,

    // Grupo Porcentual
    "PERCENTAGE_GROUPS__LIST":     () => `/grupos-porcentuales/`,
    "PERCENTAGE_GROUPS__DETAIL":   (id) => `/grupos-porcentuales/${id}/`,
    "PERCENTAGE_GROUPS__CREATE":   () => `/grupos-porcentuales/`,
    "PERCENTAGE_GROUPS__UPDATE":   (id) => `/grupos-porcentuales/${id}/`,
    "PERCENTAGE_GROUPS__DELETE":   (id) => `/grupos-porcentuales/${id}/`,

    // Porcentaje Unidad
    "UNIT_PERCENTAGES__LIST":       () => `/porcentajes-unidad/`,
    "UNIT_PERCENTAGES__DETAIL":     (id) => `/porcentajes-unidad/${id}/`,
    "UNIT_PERCENTAGES__CREATE":     () => `/porcentajes-unidad/`,
    "UNIT_PERCENTAGES__UPDATE":     (id) => `/porcentajes-unidad/${id}/`,
    "UNIT_PERCENTAGES__DELETE":     (id) => `/porcentajes-unidad/${id}/`,

    // Grupo
    "GROUPS__LIST":                 () => `/grupos/`,
    "GROUPS__DETAIL":               (id) => `/grupos/${id}/`,
    "GROUPS__CREATE":               () => `/grupos/`,
    "GROUPS__UPDATE":               (id) => `/grupos/${id}/`,
    "GROUPS__DELETE":               (id) => `/grupos/${id}/`,

    // Concepto Expensa
    "EXPENSE_CONCEPTS__LIST":       () => `/conceptos-expensa/`,
    "EXPENSE_CONCEPTS__DETAIL":     (id) => `/conceptos-expensa/${id}/`,
    "EXPENSE_CONCEPTS__CREATE":     () => `/conceptos-expensa/`,
    "EXPENSE_CONCEPTS__UPDATE":     (id) => `/conceptos-expensa/${id}/`,
    "EXPENSE_CONCEPTS__DELETE":     (id) => `/conceptos-expensa/${id}/`,
    "LIQUIDACION__EXTRACTO_CONCEPTO": (id) => `/liquidacion/concepto/${id}/extracto/`,

    // Recaudaciones Extraordinarias
    "RE__LIST":      ()    => `/recaudaciones-extraordinarias/`,
    "RE__CREATE":    ()    => `/recaudaciones-extraordinarias/`,
    "RE__DETAIL":    (id)  => `/recaudaciones-extraordinarias/${id}/`,
    "RE__UPDATE":    (id)  => `/recaudaciones-extraordinarias/${id}/`,
    "RE__DELETE":    (id)  => `/recaudaciones-extraordinarias/${id}/`,
    "RE__PREVIEW":   ()    => `/recaudaciones-extraordinarias/preview/`,
    "RE__CONFIRMAR": (id)  => `/recaudaciones-extraordinarias/${id}/confirmar/`,
    "RE__ANULAR":    (id)  => `/recaudaciones-extraordinarias/${id}/anular/`,
    "RE__NOTIFICAR": (id)  => `/recaudaciones-extraordinarias/${id}/notificar/`,

    "LIQUIDATIONS__CUENTAS_CORRIENTES_PROP_GET_LIST":   () => `/cuentascorrientes_propietarios/`,
    "LIQUIDATIONS__CUENTAS_CORRIENTES_PROP_CREATE":     () => `/cuentascorrientes_propietarios/`,
    "LIQUIDATIONS__CUENTAS_CORRIENTES_PROP_UPDATE":     (id) => `/cuentascorrientes_propietarios/${id}/`,
    "LIQUIDATIONS__CUENTAS_CORRIENTES_PROP_DELETE":     (id) => `/cuentascorrientes_propietarios/${id}/`,
    "LIQUIDATIONS__CUENTAS_CORRIENTES_PROP_GET_DETAIL": (id) => `/cuentascorrientes_propietarios/${id}/`,

    "RESUMEN__CONSORCIO_GET_LIST": (id) => `/resumen/${id}/`,
    "RESUMEN__CONSORCIO_GET_PDF":  (id) => `/resumen/${id}/pdf/`,

    // MOVEMENTS - EXPENSES SECTOR
    "MOVEMENTS__EXPENSES_SECTOR_CREATE":     () => `/rubros/`,
    "MOVEMENTS__EXPENSES_SECTOR_UPDATE":     (id) => `/rubros/${id}/`,
    "MOVEMENTS__EXPENSES_SECTOR_DELETE":     (id) => `/rubros/${id}/`,
    "MOVEMENTS__EXPENSES_SECTOR_GET_LIST":   () => `/rubros/`,
    "MOVEMENTS__EXPENSES_SECTOR_GET_DETAIL": (id) => `/rubros/${id}/`,

    // MOVEMENTS - EXPENSES ACCOUNT
    "MOVEMENTS__EXPENSES_ACCOUNT_CREATE":    () => `/cuentas/`,
    "MOVEMENTS__EXPENSES_ACCOUNT_UPDATE":    (id) => `/cuentas/${id}/`,
    "MOVEMENTS__EXPENSES_ACCOUNT_DELETE":    (id) => `/cuentas/${id}/`,
    "MOVEMENTS__EXPENSES_ACCOUNT_GET_LIST":  () => `/cuentas/`,
    "MOVEMENTS__EXPENSES_ACCOUNT_GET_DETAIL": (id) => `/cuentas/${id}/`,

    // MOVEMENTS - EXPENSES PROVIDER
    "MOVEMENTS__EXPENSES_PROVIDER_CREATE":     () => `/proveedores/`,
    "MOVEMENTS__EXPENSES_PROVIDER_UPDATE":     (id) => `/proveedores/${id}/`,
    "MOVEMENTS__EXPENSES_PROVIDER_DELETE":     (id) => `/proveedores/${id}/`,
    "MOVEMENTS__EXPENSES_PROVIDER_GET_LIST":   () => `/proveedores/`,
    "MOVEMENTS__EXPENSES_PROVIDER_GET_DETAIL": (id) => `/proveedores/${id}/`,

    // MOVEMENTS - EXPENSES EXPENSE
    "MOVEMENTS__EXPENSES_EXPENSE_CREATE":      () => `/gastos/`,
    "MOVEMENTS__EXPENSES_EXPENSE_UPDATE":      (id) => `/gastos/${id}/`,
    "MOVEMENTS__EXPENSES_EXPENSE_DELETE":      (id) => `/gastos/${id}/`,
    "MOVEMENTS__EXPENSES_EXPENSE_GET_LIST":    () => `/gastos/`,
    "MOVEMENTS__EXPENSES_EXPENSE_GET_DETAIL":  (id) => `/gastos/${id}/`,
    "MOVEMENTS__EXPENSES_EXPENSE_CONFIRM":     (id) => `/gastos/${id}/confirmar/`,
    "MOVEMENTS__EXPENSES_EXPENSE_DRAFT_SUPPLIERS": () => `/gastos/borradores-proveedores/`,
    "MOVEMENTS__EXPENSES_EXPENSE_CHECKLIST":       (id) => `/gastos/${id}/checklist-confirmacion/`,
    "MOVEMENTS__EXPENSES_EXPENSE_CHECKLIST_BATCH": (ids) => `/gastos/checklist-confirmacion-lote/?ids=${ids}`,
    "MOVEMENTS__EXPENSES_PREFILL_SUGGESTION":      () => `/gastos/prefill-sugerencia/`,

    // MOVEMENTS - EXPENSES CTA CTE PROVIDER
    "MOVEMENTS__EXPENSES_CTA_CTE_PROVIDER_GET_LIST": (id) => `/detalle_cuenta_corriente/${id}/`,
    "EXPENSES__REPORT_GET":               () => `/gastos/reporte/`,
    "EXPENSES__FACTURAS_NO_PAGADAS_GET":   () => `/gastos/facturas_no_pagadas/`,
    "EXPENSES__COMPROBANTES_IMPUTABLES_GET": () => `/gastos/comprobantes_imputables/`,
    "EXPENSES__NOTAS_CREDITO_DISPONIBLES_GET": () => `/gastos/notas_credito_disponibles/`,
    "SUPPLIERS__SUPPLIER_GET_LIST":        () => `/proveedores/`,
    "MOVEMENTS__PAYMENTS_EFFECTUATED_LIST":() => `/pagos-efectuados/`,

    // AMENITIES
    "CONSORTIUMS__AMENITI_CREATE":        () => `/ammenitis/`,
    "CONSORTIUMS__AMENITI_UPDATE":        (id) => `/ammenitis/${id}/`,
    "CONSORTIUMS__AMENITI_DELETE":        (id) => `/ammenitis/${id}/`,
    "CONSORTIUMS__AMENITI_GET_LIST":      () => `/ammenitis/`,
    "CONSORTIUMS__AMENITI_GET_DETAIL":    (id) => `/ammenitis/${id}/`,

    // Disponibilidad Amenity
    "CONSORTIUMS__AMENITY_AVAILABILITY_CREATE":              () => `/amenity-availability/`,
    "CONSORTIUMS__AMENITY_AVAILABILITY_GET_LIST_BY_AMENITI": 
  (amenityId) => `/amenity-availability/by-amenity/${amenityId}/`,

    "CONSORTIUMS__AMENITY_AVAILABILITY_DELETE":              (id) => `/amenity-availability/${id}/`,
    "CONSORTIUMS__AMENITY_AVAILABLE_SLOTS":                  () => `/amenity-available-slots/`,
    "CONSORTIUMS__AMENITI_GET_LIST_BY_CONSORTIUM": (consorcioId) => `/ammenitis/by-consorcio/${consorcioId}/`,

    // Reservas
    "CONSORTIUMS__RESERVA_CREATE":    () => `/reservas/`,
    "CONSORTIUMS__RESERVA_UPDATE":    (id) => `/reservas/${id}/`,
    "CONSORTIUMS__RESERVA_DELETE":    (id) => `/reservas/${id}/`,
    "CONSORTIUMS__RESERVA_GET_LIST":  () => `/reservas/`,

    // Mudanzas — Admin
    "MUDANZA__CONFIG_LIST":    () => `/reservas/mudanzas/configuracion/`,
    "MUDANZA__CONFIG_CREATE":  () => `/reservas/mudanzas/configuracion/`,
    "MUDANZA__CONFIG_UPDATE":  (id) => `/reservas/mudanzas/configuracion/${id}/`,
    "MUDANZA__CONFIG_DELETE":  (id) => `/reservas/mudanzas/configuracion/${id}/`,
    "MUDANZA__RESERVA_LIST":   () => `/reservas/mudanzas/reservas/`,
    "MUDANZA__RESERVA_CREATE": () => `/reservas/mudanzas/reservas/`,
    "MUDANZA__RESERVA_CANCEL": (id) => `/reservas/mudanzas/reservas/${id}/cancelar/`,

    // Mudanzas — Propietario
    "MUDANZA__PROP_DISPONIBILIDAD": () => `/api/propietario/bot/mudanzas/disponibilidad/`,
    "MUDANZA__PROP_MIS_RESERVAS":   () => `/api/propietario/bot/mudanzas/`,
    "MUDANZA__PROP_CREAR":          () => `/api/propietario/bot/mudanzas/crear/`,
    "MUDANZA__PROP_CANCEL":         (id) => `/api/propietario/bot/mudanzas/${id}/cancelar/`,

    // WhatsApp
    "WHATSAPP__HANDLE_INCOMING":       () => `/api/whatsapp/handle-incoming/`,
    "WHATSAPP__STATUS_CALLBACK":       () => `/api/whatsapp/status/`,
    "WHATSAPP__CUSTOM_MESSAGE_SEND":   () => `/api/whatsapp/custom-message/`,
    "WHATSAPP__TEMPLATE_MESSAGE_SEND": () => `/api/whatsapp/template-message/`,
    "MESSAGE_TEMPLATES__GET_LIST":       () => `/message_templates/`,
    "MESSAGE_TEMPLATES__SEND_WHATSAPP_MESSAGE": (id) =>
      `/message_templates/${id}/enviar_mensajes/`,
    // Endpoints para plantillas
    "PLANTILLAS__LIST_CREATE": () => `/api/plantillas/`,
    "PLANTILLAS__UPDATE_ESTADO": (pk) => `/api/plantillas/${pk}/estado/`,

    // IA (Chat)
    "AI__CHAT":        () => `/api/ai/chat/`,
    "AI__CHAT_STREAM": () => `/api/ai/chat/stream/`,

    // MOVIMIENTOS FINANCIEROS (NUEVA APP)
   // MOVIMIENTOS FINANCIEROS (NUEVA APP)
  "FINANCIAL_MOVEMENTS__GET_LIST":    () => `/movimientos_financieros/`,
  "FINANCIAL_MOVEMENTS__CREATE":      () => `/movimientos_financieros/`,
  "FINANCIAL_MOVEMENTS__GET_DETAIL":  (id) => `/movimientos_financieros/${id}/`,
  "FINANCIAL_MOVEMENTS__UPDATE":      (id) => `/movimientos_financieros/${id}/`,
  "FINANCIAL_MOVEMENTS__DELETE":      (id) => `/movimientos_financieros/${id}/`,
  "FINANCIAL_MOVEMENTS__CONFIRM":     (id) => `/movimientos_financieros/${id}/confirmar/`,
  "FINANCIAL_MOVEMENTS__ANULAR":      (id) => `/movimientos_financieros/${id}/anular/`,

  
    // REPORTES GENERALES
    "REPORTS__GENERAL_GET_LIST":   () => `/informes-generales/`,
    "REPORTS__GENERAL_GET_DETAIL": (id) => `/informes-generales/${id}/`,
    "REPORTS__GENERAL_CREATE":     () => `/informes-generales/`,
    "REPORTS__GENERAL_UPDATE":     (id) => `/informes-generales/${id}/`,
    "REPORTS__GENERAL_DELETE":     (id) => `/informes-generales/${id}/`,
    "REPORTS__GENERAL_RESEND":     (id) => `/informes-generales/${id}/reenviar/`,

    // CONVENIOS
    "CONVENIOS__GET_LIST": () => `/convenios/`,
    "CONVENIOS__CREATE":   () => `/convenios/`,
    "CONVENIOS__UPDATE":   (id) => `/convenios/${id}/`,
    "CONVENIOS__DELETE":   (id) => `/convenios/${id}/`,

    // Encargados Consorcio
    "ENCARGADOS__GET_LIST":              () => `/encargados-consorcio/`,
    "ENCARGADOS__CREATE":                () => `/encargados-consorcio/`,
    "ENCARGADOS__UPDATE":                (id) => `/encargados-consorcio/${id}/`,
    "ENCARGADOS__DELETE":                (id) => `/encargados-consorcio/${id}/`,
    "ENCARGADOS__GET_LIST_BY_CONSORCIO":  (consorcioId) => `/encargados-consorcio/por_consorcio/?consorcio_id=${consorcioId}`,

    // Conceptos Remunerativos
    "CONCEPTOS_REMUNERATIVOS__GET_LIST":  () => `/conceptos-remunerativos/`,
    "CONCEPTOS_REMUNERATIVOS__CREATE":    () => `/conceptos-remunerativos/`,
    "CONCEPTOS_REMUNERATIVOS__UPDATE":    (id) => `/conceptos-remunerativos/${id}/`,
    "CONCEPTOS_REMUNERATIVOS__DELETE":    (id) => `/conceptos-remunerativos/${id}/`,

    // Conceptos No Remunerativos
    "CONCEPTOS_NO_REMUNERATIVOS__GET_LIST":   () => `/conceptos-no-remunerativos/`,
    "CONCEPTOS_NO_REMUNERATIVOS__CREATE":     () => `/conceptos-no-remunerativos/`,
    "CONCEPTOS_NO_REMUNERATIVOS__UPDATE":     (id) => `/conceptos-no-remunerativos/${id}/`,
    "CONCEPTOS_NO_REMUNERATIVOS__DELETE":     (id) => `/conceptos-no-remunerativos/${id}/`,
    "CONCEPTOS_PARA_LIQUIDACION__DISPONIBLES": () => `/conceptos-para-liquidacion/disponibles/`,

    // Descuentos Convenio
    "DESCUENTOS_CONVENIO__GET_LIST":  () => `/descuentos-convenio/`,
    "DESCUENTOS_CONVENIO__CREATE":    () => `/descuentos-convenio/`,
    "DESCUENTOS_CONVENIO__UPDATE":    (id) => `/descuentos-convenio/${id}/`,
    "DESCUENTOS_CONVENIO__DELETE":    (id) => `/descuentos-convenio/${id}/`,

    // Liquidaciones Sueldo
    "LIQUIDACIONES_SUELDO__GET_LIST": () => `/liquidaciones-sueldo/`,
    "LIQUIDACIONES_SUELDO__CREATE":   () => `/liquidaciones-sueldo/`,
    "LIQUIDACIONES_SUELDO__UPDATE":   (id) => `/liquidaciones-sueldo/${id}/`,
    "LIQUIDACIONES_SUELDO__DELETE":   (id) => `/liquidaciones-sueldo/${id}/`,
    "LIQUIDACIONES_SUELDO__DETAIL":   (id) => `/liquidaciones-sueldo/${id}/`,
    "LIQUIDACIONES_SUELDO__CONFIRMAR_LIQUIDACION": (id) => `/liquidaciones-sueldo/${id}/confirmar_liquidacion/`,
    "SUELDOS__CONCEPTOS_PARA_LIQUIDACION": () => `/sueldos/conceptos-para-liquidacion/disponibles/`,
    "LIQUIDACIONES_SUELDO__EDITAR_DETALLES": (id) => `/liquidaciones-sueldo/${id}/editar_detalles/`,
    "LIQUIDACIONES_SUELDO__RESUMEN_PERIODO": () => `/liquidaciones-sueldo/resumen-periodo/`,
    "LIQUIDACIONES_SUELDO__GENERAR_MASIVO":  () => `/liquidaciones-sueldo/generar-masivo/`,
    "RECONCILIATIONS__GET_COMPARISON": (id) => `/conciliaciones/${id}/comparacion/`,



    // _uriConstructor.js (ejemplo)
    CONSORTIUMS__BANK_CHECKING_ACCOUNT_MOV_DETAIL: (idData) =>
  `/cuenta-corriente-banco/movimiento-detalle/${idData}/`,
    // src/_API/_uriConstructor.js
    FINANCIAL_MOVEMENTS__TRACE_DETAIL: (id) => `/movimientos/${id}/trazabilidad/`,



    





    // Novedades Liquidación
    "NOVELTIES__NOVELTY_GET_LIST":   () => `/novedades-liquidacion/`,
    "NOVELTIES__NOVELTY_CREATE":     () => `/novedades-liquidacion/`,
    "NOVELTIES__NOVELTY_UPDATE":     (id) => `/novedades-liquidacion/${id}/`,
    "NOVELTIES__NOVELTY_DELETE":     (id) => `/novedades-liquidacion/${id}/`,
    "NOVELTIES__NOVELTY_GET_DETAIL": (id) => `/novedades-liquidacion/${id}/`,

    // Solicitudes de novedad cargadas por el encargado desde el bot.
    // Van bajo /sueldos/ porque el ViewSet se registró en sueldos/urls.py,
    // a diferencia de novedades-liquidacion que además está en el router raíz.
    "NOVELTY_REQUESTS__GET_LIST":        () => `/sueldos/solicitudes-novedad/`,
    "NOVELTY_REQUESTS__PENDING_COUNT":   () => `/sueldos/solicitudes-novedad/pendientes-count/`,
    "NOVELTY_REQUESTS__APPROVE":         (id) => `/sueldos/solicitudes-novedad/${id}/aprobar/`,
    "NOVELTY_REQUESTS__REJECT":          (id) => `/sueldos/solicitudes-novedad/${id}/rechazar/`,

    "CATEGORIAS_CCT__GET_LIST":  () => `/categorias-cct/`,
    "CATEGORIAS_CCT__CREATE":    () => `/categorias-cct/`,
    "CATEGORIAS_CCT__UPDATE":    (id) => `/categorias-cct/${id}/`,
    "CATEGORIAS_CCT__DELETE":    (id) => `/categorias-cct/${id}/`,
    "CATEGORIAS_CCT__DETAIL":    (id) => `/categorias-cct/${id}/`,

    "ESCALAS_SALARIALES__GET_LIST": () => `/escalas-salariales/`,
    "ESCALAS_SALARIALES__CREATE":   () => `/escalas-salariales/`,
    "ESCALAS_SALARIALES__UPDATE":   (id) => `/escalas-salariales/${id}/`,
    "ESCALAS_SALARIALES__DELETE":   (id) => `/escalas-salariales/${id}/`,
    "ESCALAS_SALARIALES__DETAIL":   (id) => `/escalas-salariales/${id}/`,

    "ALICUOTAS_APORTE_PATRONAL__GET_LIST": () => `/alicuotas-aporte-patronal/`,

    "ALICUOTAS_ART_CONSORCIO__GET_LIST": () => `/alicuotas-art-consorcio/`,
    "ALICUOTAS_ART_CONSORCIO__CREATE":   () => `/alicuotas-art-consorcio/`,
    "ALICUOTAS_ART_CONSORCIO__UPDATE":   (id) => `/alicuotas-art-consorcio/${id}/`,
    "ALICUOTAS_ART_CONSORCIO__DELETE":   (id) => `/alicuotas-art-consorcio/${id}/`,
    "ALICUOTAS_ART_CONSORCIO__DETAIL":   (id) => `/alicuotas-art-consorcio/${id}/`,

    // ACCESO TERCEROS
    "ACCESO_TERCEROS_CREATE":     () => `/acceso-terceros/`,
    "ACCESO_TERCEROS_UPDATE":     (id) => `/acceso-terceros/${id}/`,
    "ACCESO_TERCEROS_DELETE":     (id) => `/acceso-terceros/${id}/`,
    "ACCESO_TERCEROS_GET_LIST":   () => `/acceso-terceros/`,
    "ACCESO_TERCEROS_DETAIL":     (id) => `/acceso-terceros/${id}/`,

    // FOLDERS
    "FOLDERS__LOCAL_GET_LIST": () => "/local-folders/",
    "API__DELETE_FILE": (filePath) => `/api/delete-file/?file_path=${filePath}`,
    "FOLDERS__LOCAL_GET_PUBLIC_LIST": (_, params = {}) => {
      const adminId = params.admin_id || '9';
      return `/local-folders-public/?admin_id=${adminId}`;
    },

    "SEGUROS__GET_LIST": () => `/seguros/`,
    "SEGUROS__CREATE": () => `/seguros/`,
    "SEGUROS__GET_DETAIL": (id) => `/seguros/${id}/`,
    "SEGUROS__UPDATE": (id) => `/seguros/${id}/`,
    "SEGUROS__DELETE": (id) => `/seguros/${id}/`,

    // =========================================
    // PLANES DE PAGO (ARCA / AGIP / ARBA)
    // =========================================
    "PLANES__GET_LIST":              ()    => `/planes-pago/`,
    "PLANES__CREATE":                ()    => `/planes-pago/`,
    "PLANES__GET_DETAIL":            (id)  => `/planes-pago/${id}/`,
    "PLANES__UPDATE":                (id)  => `/planes-pago/${id}/`,
    "PLANES__DELETE":                (id)  => `/planes-pago/${id}/`,
    "PLANES__DOCUMENTO_PDF":         (id)  => `/planes-pago/${id}/documento-pdf/`,
    "PLANES__CUOTAS_GET_LIST":       ()    => `/planes-pago/cuotas/`,
    // dentro de URI_SELECTED
    "PLANES__REPORT": () => `/planes-pago/reporte/`,


    // NUEVA SECCIÓN: CHAT
      "CHAT__GET_CONVERSACIONES": () => `/api/chat/conversaciones/`,
      "CHAT__GET_MENSAJES": (id) => `/api/chat/conversaciones/${id}/mensajes/`,
      "CHAT__ENVIAR_MENSAJE": (id) => `/api/chat/conversaciones/${id}/enviar_mensaje/`,
    

    // WhatsApp
    "WHATSAPP__HANDLE_INCOMING":         () => `/api/whatsapp/handle-incoming/`,
    "WHATSAPP__STATUS_CALLBACK":         () => `/api/whatsapp/status/`,
    "WHATSAPP__CUSTOM_MESSAGE_SEND":     () => `/api/whatsapp/custom-message/`,
    "WHATSAPP__TEMPLATE_MESSAGE_SEND":   () => `/api/whatsapp/template-message/`,
    "MESSAGE_TEMPLATES__GET_LIST":       () => `/message_templates/`,
    "MESSAGE_TEMPLATES__SEND_WHATSAPP_MESSAGE": (id) => `/message_templates/${id}/enviar_mensajes/`,
    "PLANTILLAS__LIST_CREATE":           () => `/api/plantillas/`,
    "PLANTILLAS__UPDATE_ESTADO":         (pk) => `/api/plantillas/${pk}/estado/`,
    "BIENVENIDA_PROPIETARIOS__LIST":   () => `/api/bienvenida_propietarios/`,
    "BIENVENIDA_PROPIETARIOS__ENVIAR": (id) => `/api/bienvenida_propietarios/${id}/enviar/`,

    // OWNER HUB (por Propietario)
"OWNER__LIQUIDACIONES_BY_OWNER":     (propId) => `/liquidaciones/?propietario_id=${propId}`,
"OWNER__COBRANZAS_BY_OWNER":         (propId) => `/cobranzas/?propietario_id=${propId}`,
"OWNER__RECLAMOS_BY_OWNER":          (propId) => `/api/reclamos/?propietario_id=${propId}`,
"OWNER__SOLICITUDES_BY_OWNER":       (propId) => `/solicitudes/?propietario_id=${propId}`,   // si tu API expone este módulo
"OWNER__RESERVAS_BY_OWNER":          (propId) => `/reservas/?propietario_id=${propId}`,
"OWNER__CTA_CTE_DETAIL":             (propId) => `/propietarios/${propId}/cuenta-corriente/`,
"OWNER__CTA_CTE_LIST":               (propId) => `/cuentascorrientes_propietarios/?propietario_id=${propId}`,

 // ───────────────────────── MOROSIDAD ─────────────────────────
"MOROSIDAD__LIST":       ()    => `/consorcios/morosidad/deudores/`,
"MOROSIDAD__PREVIEW":    ()    => `/consorcios/morosidad/preview/`,
"MOROSIDAD__ENVIAR":     ()    => `/consorcios/morosidad/enviar/`,
"MOROSIDAD__CONFIG":     ()    => `/consorcios/morosidad/config/`,
"MOROSIDAD__HISTORY":    ()    => `/consorcios/morosidad/historial/`,
"MOROSIDAD__RESEND":     (id)  => `/consorcios/morosidad/${id}/reenviar/`,
"MOROSIDAD__TPL_LIST":   ()    => `/consorcios/morosidad/plantillas/`,
"MOROSIDAD__TPL_SET_DEF":(id)  => `/consorcios/morosidad/plantillas/${id}/set_default/`,
"MOROSIDAD__TPL_TOKENS": ()    => `/consorcios/morosidad/plantillas/tokens/`,


    // IA (Chat)
    "AI__CHAT":        () => `/api/ai/chat/`,
    "AI__CHAT_STREAM": () => `/api/ai/chat/stream/`,

    // IA (Texto)
    "AI__TEXT_IMPROVER": () => `/api/ai-text-improver/`,

    // Add-ons
    "ADDONS__STATUS": () => `/addons/status/`,

    // Contabilidad Admin
    "CONTAB_ADMIN__PING": () => `/api/contabilidad-admin/ping/`,
    "CONTAB_ADMIN__DASHBOARD": () => `/api/contabilidad-admin/dashboard/`,
    "CONTAB_ADMIN__CUENTAS": () => `/api/contabilidad-admin/cuentas/`,
    "CONTAB_ADMIN__CUENTAS_DETAIL": (id) => `/api/contabilidad-admin/cuentas/${id}/`,
    "CONTAB_ADMIN__PERIODOS": () => `/api/contabilidad-admin/periodos/`,
    "CONTAB_ADMIN__PERIODOS_DETAIL": (id) => `/api/contabilidad-admin/periodos/${id}/`,
    "CONTAB_ADMIN__PERIODO_CERRAR": (id) => `/api/contabilidad-admin/periodos/${id}/cerrar/`,
    "CONTAB_ADMIN__PERIODO_GENERAR_CIERRE": (id) => `/api/contabilidad-admin/periodos/${id}/generar-cierre/`,
    "CONTAB_ADMIN__PERIODO_RESUMEN_PDF": (id) => `/api/contabilidad-admin/periodos/${id}/resumen-pdf/`,
    "CONTAB_ADMIN__PERIODOS_PONERSE_AL_DIA": () => `/api/contabilidad-admin/periodos/ponerse-al-dia/`,
    "CONTAB_ADMIN__ASIENTOS": () => `/api/contabilidad-admin/asientos/`,
    "CONTAB_ADMIN__ASIENTO_DETAIL": (id) => `/api/contabilidad-admin/asientos/${id}/`,
    "CONTAB_ADMIN__REPORT_BALANCE": () => `/api/contabilidad-admin/reportes/balance-sumas-saldos/`,
    "CONTAB_ADMIN__REPORT_ER": () => `/api/contabilidad-admin/reportes/estado-resultados/`,
    "CONTAB_ADMIN__REPORT_BALANCE_GENERAL": () => `/api/contabilidad-admin/reportes/balance-general/`,
    "CONTAB_ADMIN__MAYOR": () => `/api/contabilidad-admin/mayor/`,
    "CONTAB_ADMIN__VENTAS": () => `/api/contabilidad-admin/ventas/`,
    "CONTAB_ADMIN__VENTA_SYNC": (id) => `/api/contabilidad-admin/ventas/${id}/sync/`,
    "CONTAB_ADMIN__COBRANZAS": () => `/api/contabilidad-admin/cobranzas/`,
    "CONTAB_ADMIN__COBRANZA_SYNC": (id) => `/api/contabilidad-admin/cobranzas/${id}/sync/`,
    "CONTAB_ADMIN__SYNC_RANGE": () => `/api/contabilidad-admin/sync/`,
    "CONTAB_ADMIN__REGISTRAR_OPCIONES": () => `/api/contabilidad-admin/registrar/opciones/`,
    "CONTAB_ADMIN__REGISTRAR_FACTURA": () => `/api/contabilidad-admin/registrar/factura-recibida/`,
    "CONTAB_ADMIN__REGISTRAR_PAGO": () => `/api/contabilidad-admin/registrar/pago/`,
    "CONTAB_ADMIN__REGISTRAR_TRANSFERENCIA": () => `/api/contabilidad-admin/registrar/transferencia/`,
    "CONTAB_ADMIN__REGISTRAR_COBRO_PROVEEDOR": () => `/api/contabilidad-admin/registrar/cobro-proveedor/`,
    "CONTAB_ADMIN__COMPRAS": () => `/api/contabilidad-admin/compras/`,
    "CONTAB_ADMIN__COMPRA_DETAIL": (id) => `/api/contabilidad-admin/compras/${id}/`,
    "CONTAB_ADMIN__COMPRA_SYNC": (id) => `/api/contabilidad-admin/compras/${id}/sync/`,
    "CONTAB_ADMIN__COMPRA_ANULAR": (id) => `/api/contabilidad-admin/compras/${id}/anular/`,
    "CONTAB_ADMIN__PAGOS_ADMIN": () => `/api/contabilidad-admin/pagos-admin/`,
    "CONTAB_ADMIN__PAGOS_ADMIN_FORM_OPTIONS": () => `/api/contabilidad-admin/pagos-admin/form-options/`,
    "CONTAB_ADMIN__PAGO_ADMIN_DETAIL": (id) => `/api/contabilidad-admin/pagos-admin/${id}/`,
    "CONTAB_ADMIN__PAGO_ADMIN_SYNC": (id) => `/api/contabilidad-admin/pagos-admin/${id}/sync/`,
    "CONTAB_ADMIN__PAGO_ADMIN_ANULAR": (id) => `/api/contabilidad-admin/pagos-admin/${id}/anular/`,
    "CONTAB_ADMIN__SYNC_EGRESOS": () => `/api/contabilidad-admin/sync-egresos/`,
    "CONTAB_ADMIN__CONFIG": () => `/api/contabilidad-admin/config/`,
    "CONTAB_ADMIN__CONFIG_SUGGESTION": () => `/api/contabilidad-admin/config/suggestion/`,
    "CONTAB_ADMIN__ACCESS_USERS": () => `/api/contabilidad-admin/access/users/`,
    "CONTAB_ADMIN__ACCESS_USER_DETAIL": (userId) => `/api/contabilidad-admin/access/users/${userId}/`,
    "CONTAB_ADMIN__APERTURA": () => `/api/contabilidad-admin/apertura/`,
    "CONTAB_ADMIN__ONBOARDING_STATUS": () => `/api/contabilidad-admin/onboarding/status/`,
    "CONTAB_ADMIN__AUDITORIA": () => `/api/contabilidad-admin/auditoria/`,
    "CONTAB_ADMIN__IVA_VENTAS": () => `/api/contabilidad-admin/impuestos/iva/ventas/`,
    "CONTAB_ADMIN__IVA_COMPRAS": () => `/api/contabilidad-admin/impuestos/iva/compras/`,
    "CONTAB_ADMIN__IVA_RESUMEN": () => `/api/contabilidad-admin/impuestos/iva/resumen/`,
    "CONTAB_ADMIN__IVA_EXPORT": () => `/api/contabilidad-admin/impuestos/iva/export.xlsx`,
    "CONTAB_ADMIN__IVA_AJUSTES": () => `/api/contabilidad-admin/impuestos/iva/ajustes/`,
    "CONTAB_ADMIN__IIBB_BASE": () => `/api/contabilidad-admin/impuestos/iibb/base/`,
    "CONTAB_ADMIN__IIBB_MOVIMIENTOS": () => `/api/contabilidad-admin/impuestos/iibb/movimientos/`,
    "CONTAB_ADMIN__IIBB_RESUMEN": () => `/api/contabilidad-admin/impuestos/iibb/resumen/`,
    "CONTAB_ADMIN__IIBB_EXPORT": () => `/api/contabilidad-admin/impuestos/iibb/export.xlsx`,
    "CONTAB_ADMIN__IIBB_MAPPINGS": () => `/api/contabilidad-admin/impuestos/iibb/mappings/`,
    "CONTAB_ADMIN__IIBB_MAPPING_DETAIL": (consorcioId) => `/api/contabilidad-admin/impuestos/iibb/mappings/${consorcioId}/`,
    "CONTAB_ADMIN__GANANCIAS_RESUMEN": () => `/api/contabilidad-admin/impuestos/ganancias/resumen/`,
    "CONTAB_ADMIN__GANANCIAS_DETALLE": () => `/api/contabilidad-admin/impuestos/ganancias/detalle-cuentas/`,
    "CONTAB_ADMIN__GANANCIAS_EXPORT": () => `/api/contabilidad-admin/impuestos/ganancias/export.xlsx`,
    "CONTAB_ADMIN__CONCILIACION_IMPORT": () => `/api/contabilidad-admin/conciliacion/importar/`,
    "CONTAB_ADMIN__CONCILIACION_IMPORT_DETAIL": (id) => `/api/contabilidad-admin/conciliacion/${id}/`,
    "CONTAB_ADMIN__CONCILIACION_LINEAS": (id) => `/api/contabilidad-admin/conciliacion/${id}/lineas/`,
    "CONTAB_ADMIN__CONCILIACION_MATCH": (id) => `/api/contabilidad-admin/conciliacion/${id}/matchear/`,
    "CONTAB_ADMIN__CONCILIACION_COMPARACION": (id) => `/api/contabilidad-admin/conciliacion/${id}/comparacion/`,
    "CONTAB_ADMIN__CONCILIACION_MANUAL": (lineId) => `/api/contabilidad-admin/conciliacion/linea/${lineId}/marcar/`,
    "CONTAB_ADMIN__CTACTE_CLIENTES": () => `/api/contabilidad-admin/ctacte/clientes/`,
    "CONTAB_ADMIN__CTACTE_CLIENTE_DETAIL": (id) => `/api/contabilidad-admin/ctacte/clientes/${id}/`,
    "CONTAB_ADMIN__CTACTE_CLIENTES_EXPORT_XLSX": () => `/api/contabilidad-admin/ctacte/clientes/export.xlsx`,
    "CONTAB_ADMIN__CTACTE_CLIENTES_EXPORT_PDF": () => `/api/contabilidad-admin/ctacte/clientes/export.pdf`,
    "CONTAB_ADMIN__CTACTE_CLIENTE_DETAIL_EXPORT_XLSX": (id) => `/api/contabilidad-admin/ctacte/clientes/${id}/export.xlsx`,
    "CONTAB_ADMIN__CTACTE_CLIENTE_DETAIL_EXPORT_PDF": (id) => `/api/contabilidad-admin/ctacte/clientes/${id}/export.pdf`,
    "CONTAB_ADMIN__CTACTE_PROVEEDORES": () => `/api/contabilidad-admin/ctacte/proveedores/`,
    "CONTAB_ADMIN__CTACTE_PROVEEDOR_DETAIL": (slug) => `/api/contabilidad-admin/ctacte/proveedores/${slug}/`,
    "CONTAB_ADMIN__CTACTE_PROVEEDORES_EXPORT_XLSX": () => `/api/contabilidad-admin/ctacte/proveedores/export.xlsx`,
    "CONTAB_ADMIN__CTACTE_PROVEEDORES_EXPORT_PDF": () => `/api/contabilidad-admin/ctacte/proveedores/export.pdf`,
    "CONTAB_ADMIN__CTACTE_PROVEEDOR_DETAIL_EXPORT_XLSX": (slug) => `/api/contabilidad-admin/ctacte/proveedores/${slug}/export.xlsx`,
    "CONTAB_ADMIN__CTACTE_PROVEEDOR_DETAIL_EXPORT_PDF": (slug) => `/api/contabilidad-admin/ctacte/proveedores/${slug}/export.pdf`,
    "CONTAB_ADMIN__CTACTE_BANCOS": () => `/api/contabilidad-admin/ctacte/bancos/`,
    "CONTAB_ADMIN__CTACTE_BANCO_DETAIL": (id) => `/api/contabilidad-admin/ctacte/bancos/${id}/`,
    "CONTAB_ADMIN__SUELDOS_EMPLEADOS": () => `/api/contabilidad-admin/sueldos/empleados/`,
    "CONTAB_ADMIN__SUELDOS_EMPLEADO_DETAIL": (id) => `/api/contabilidad-admin/sueldos/empleados/${id}/`,
    "CONTAB_ADMIN__SUELDOS_CONCEPTOS": () => `/api/contabilidad-admin/sueldos/conceptos/`,
    "CONTAB_ADMIN__SUELDOS_CONCEPTO_DETAIL": (id) => `/api/contabilidad-admin/sueldos/conceptos/${id}/`,
    "CONTAB_ADMIN__SUELDOS_LIQUIDACIONES": () => `/api/contabilidad-admin/sueldos/liquidaciones/`,
    "CONTAB_ADMIN__SUELDOS_LIQUIDACION_DETAIL": (id) => `/api/contabilidad-admin/sueldos/liquidaciones/${id}/`,
    "CONTAB_ADMIN__SUELDOS_LIQUIDACION_CONFIRM": (id) => `/api/contabilidad-admin/sueldos/liquidaciones/${id}/confirmar/`,
    "CONTAB_ADMIN__SUELDOS_LIQUIDACION_ANULAR": (id) => `/api/contabilidad-admin/sueldos/liquidaciones/${id}/anular/`,
    "CONTAB_ADMIN__SUELDOS_LIQUIDACION_SYNC": (id) => `/api/contabilidad-admin/sueldos/liquidaciones/${id}/sync/`,
    "CONTAB_ADMIN__SUELDOS_LIQUIDACION_RECIBO": (id) => `/api/contabilidad-admin/sueldos/liquidaciones/${id}/generar-recibo/`,
    "CONTAB_ADMIN__SUELDOS_LIQUIDACION_COPY": () => `/api/contabilidad-admin/sueldos/liquidaciones/copiar/`,
    "CONTAB_ADMIN__SUELDOS_PAGOS": () => `/api/contabilidad-admin/sueldos/pagos/`,
    "CONTAB_ADMIN__SUELDOS_PAGO_DETAIL": (id) => `/api/contabilidad-admin/sueldos/pagos/${id}/`,
    "CONTAB_ADMIN__SUELDOS_PAGO_CONFIRM": (id) => `/api/contabilidad-admin/sueldos/pagos/${id}/confirmar/`,
    "CONTAB_ADMIN__SUELDOS_PAGO_ANULAR": (id) => `/api/contabilidad-admin/sueldos/pagos/${id}/anular/`,
    "CONTAB_ADMIN__SUELDOS_PAGO_SYNC": (id) => `/api/contabilidad-admin/sueldos/pagos/${id}/sync/`,
    "CONTAB_ADMIN__SUELDOS_REPORT_RESUMEN": () => `/api/contabilidad-admin/sueldos/reportes/resumen/`,
    "CONTAB_ADMIN__SUELDOS_REPORT_RESUMEN_XLSX": () => `/api/contabilidad-admin/sueldos/reportes/resumen.xlsx`,
    "CONTAB_ADMIN__TERMS": () => `/api/contabilidad-admin/terms/`,
    "CONTAB_ADMIN__TERMS_STATUS": () => `/api/contabilidad-admin/terms/status/`,
    "CONTAB_ADMIN__TERMS_ACCEPT": () => `/api/contabilidad-admin/terms/accept/`,

    // --------------------------------------------
    // DASHBOARD (Fase 1 backend: commit caa64e57)
    // --------------------------------------------
    "DASHBOARD__KPIS_GET": () => `/api/dashboard/kpis/`,
    // Fase 3 backend (ya en main): 4 tarjetas nuevas, 2 endpoints
    // separados por costo (financiero: gastos/pagos/saldos; cobranzas:
    // su propia query más pesada) + notas. Igual patrón que KPIS_GET --
    // sin query params acá, viajan como PARAMS de ApiConsume.
    "DASHBOARD__FINANCIERO_GET": () => `/api/dashboard/financiero/`,
    "DASHBOARD__COBRANZAS_GET": () => `/api/dashboard/cobranzas/`,
    "DASHBOARD__NOTAS_GET": () => `/api/dashboard/notas/`,
    // Fase 5 backend (ya en main): serie de 12 meses para los gráficos
    // de tendencia. Solo recibe consorcio -- la ventana es siempre los
    // últimos 12 meses calendario, independiente de año/mes.
    "DASHBOARD__TENDENCIAS_GET": () => `/api/dashboard/tendencias/`,
  };

  if (!URI_SELECTED[formattedSection]) {
    throw new Error(`Endpoint for section ${formattedSection} is not defined.`);
  }

  return idData !== null
    ? URI_SELECTED[formattedSection](idData)
    : URI_SELECTED[formattedSection](params);
};
